import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', color = 'black', withText = true, className = '' }) => {
  const sizeClass = `spinner-${size}`;
  const colorClass = `spinner-${color}`;
  
  return (
    <div className={`spinner-container ${className}`}>
      <div className={`loading-spinner ${sizeClass} ${colorClass}`}></div>
      {withText && <p className={`loading-text text-${color}`}>جاري التحميل...</p>}
    </div>
  );
};

export default LoadingSpinner;
